import CalendarModeBaseView from './CalendarModeBaseView';
import EventsCalendarViewMode from './EventsCalendarViewMode';
import EventWeekTable from './html/EventWeekTable';
import EventWeekList from './html/EventWeekList';
import RangeFormatter from '../date/EventListingRangeFormatter';
import { startOfWeek, endOfWeek, endOfDay } from '../date/DateHelpers';
import { Days } from './generateCalendarWeeks';

class CalendarWeekView extends CalendarModeBaseView {
  constructor(store, config) {
    super(
      store,
      config,
      EventsCalendarViewMode.WEEK,
    );

    const firstDayOfWeek = window.tnew?.app?.calendarViewConfig?.firstDayOfWeek || Days.Sunday;
    this.setResultViews([
      new EventWeekTable(firstDayOfWeek),
      new EventWeekList(),
    ]);
  }

  async initDatepicker(DatePicker, { date, minDate, maxDate }) {
    this.datePicker = new DatePicker({
      date,
      minDate,
      maxDate,
      id: 'tn-event-calendar-input-week',
      label: 'Select Week',
      rangeType: DatePicker.RangeType.WEEK,
      dateFormatter: RangeFormatter.weekRange,
      onChange: this.onDateChange.bind(this),
    });
  }

  getRangeForSelectedDate() {
    const { selectedDate: date } = this;

    return {
      startDate: startOfWeek(date),
      endDate: endOfDay(endOfWeek(date)),
    };
  }
}

export default CalendarWeekView;
